import { atom, useAtom } from 'jotai';

export type AddSetContinuation = {
  deliveryId: string;
  kitInstanceId: string;
  providedSetName: string;
  unavailableTrayNumbers: number[];
};

const addSetContinuationAtom = atom<AddSetContinuation | null>(null);

export const useAddSetContinuation = () => useAtom(addSetContinuationAtom);
